import { render } from "./ChapterList.vue?vue&type=template&id=397267c1&scoped=true"
import script from "./ChapterList.vue?vue&type=script&lang=js"
export * from "./ChapterList.vue?vue&type=script&lang=js"

import "./ChapterList.vue?vue&type=style&index=0&id=397267c1&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397267c1"]])

export default __exports__